import {isSchemaTag, Tag} from 'folder-items/FileConstants';

/** @package */
export function generateKeyForSystemField(fieldLabel: string): string {
  return `systemField-${fieldLabel}`;
}

export function generateKeyForSchemaField(tag: Tag): string {
  return isSchemaTag(tag) ? tag.tagSchemaField.apiId : `tsf_${tag.id ?? tag.name}`;
}
